import api from './api';

// Una fila de la tabla EntregaFolleto (cliente asignado o ya entregado).
export interface ClienteFolleto {
  entrega_id: number;
  cliente_nombre: string;
  ejecutivo_cedula?: string;
  ejecutivo_nombre?: string;
  origen?: string;
  estado: string;            // PENDIENTE | ENTREGADO
  contacto_nombre?: string;
  contacto_pais?: string;
  contacto_telefono?: string;
  mensaje_estado?: string;   // PENDIENTE | ENVIADO | ERROR
  respuesta?: string | null; // SI | NO | null
  fecha_entrega?: string | null;
}

export interface RegistrarPayload {
  entrega_id?: number;       // cuando es un cliente de la lista
  cliente_nombre?: string;   // cuando es un cliente del buscador (fuera de lista)
  contacto_nombre?: string;
  contacto_pais: string;     // ej "+595"
  contacto_telefono: string; // solo la parte local (digitos)
  observacion?: string;
}

export default {
  // Lista los clientes asignados al ejecutivo logueado.
  async clientes() {
    return api.get('entregas-folleto/clientes');
  },
  // Registra la entrega del folleto (y dispara el WhatsApp en el backend).
  async registrar(payload: RegistrarPayload) {
    return api.post('entregas-folleto/registrar', payload);
  },
};
